import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

/** The field's name, as ContactController::HONEYPOT_FIELD reads it. */
export const HONEYPOT_FIELD = 'contact_reference';

/**
 * The forms' honeypot: a text field a person never sees, hears or reaches
 * (off screen, aria-hidden, out of the tab order, no autofill), which a bot
 * filling every field fills too. ContactController answers a submission
 * that carries it as a success and sends it nowhere.
 *
 * Uncontrolled, and read from its ref when the form is sent, so a value set
 * straight on the element (not typed) counts as well. Spread
 * `honeypotPayload(ref.current?.value)` into the request body.
 */
const Honeypot = forwardRef(function Honeypot(props, ref) {
    const { formatMessage } = useIntl();

    return (
        <div aria-hidden="true" className="pointer-events-none absolute -left-[10000px] top-0 size-px overflow-hidden">
            <label>
                {formatMessage({ id: 'site.form.honeypot' })}
                <input ref={ref} type="text" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" defaultValue="" />
            </label>
        </div>
    );
});

export default Honeypot;

/** The honeypot's part of a request body: nothing unless it was filled. */
export function honeypotPayload(value) {
    return value ? { [HONEYPOT_FIELD]: value } : {};
}
